import { formatISOForFilename } from 'support/helpers/dateTime/dateTime';

export const generateTimestampedFilename = (fileName: string): string => {
  const timestamp = formatISOForFilename();
  const lastDotIndex = fileName.lastIndexOf('.');
  const hasExtension = lastDotIndex > 0 && lastDotIndex < fileName.length - 1;

  const baseName = hasExtension ? fileName.substring(0, lastDotIndex) : fileName;
  const extension = hasExtension ? fileName.substring(lastDotIndex + 1) : '';
  return hasExtension ? `${baseName}_${timestamp}.${extension}` : `${baseName}_${timestamp}`;
};

export const uploadFileToS3WithPresignedUrl = async (file: File, presignedUrl: string): Promise<void> => {
  const response = await fetch(presignedUrl, {
    method: 'PUT',
    body: file,
    headers: {
      'Content-Type': file.type,
    },
  });

  if (!response.ok) {
    throw new Error(`Upload failed with status: ${response.status}`);
  }
};
